import { useEffect, useState } from "react"
import Button from "../../UI/Button/Button"
import Select from "../../UI/Select/Select"
import Input from "../../UI/Input/Input"
import fetchData from "../../../shared/fetchData";
import { checkValidity, updateObject } from "../../../shared/utility";
import { Row } from "reactstrap"

const RaiseCredit = (props) => {

    const [raiseReason, setRaiseReason] = useState('');
    const [raiseReasons, setRaiseReasons] = useState([]);
    const [raiseValid, setRaiseValid] = useState(true);
    const [raise, setRaise] = useState({
        amount: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'مبلغ افزایش اعتبار',
                unit: 'ریال'
            },
            validation: {
                required: true
            },
            errorMessage: 'فیلد الزامی است',
            valid: true,
            value: ''
        },
        comment: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'توضیحات'
            },
            validation: {
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })
    useEffect(() => {

        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/units/getIncreaseReasons'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setRaiseReasons(result.creditChangeTypes)
            })
            .catch(error => console.log(error))
    }, [props.unitId])

    const raiseSubmit = (event) => {
        let rs = { ...raise };
        let hasError = false
        for (let key in rs) {
            let element = { ...rs[key] }
            if (!checkValidity(rs[key].value, rs[key].validation)) {
                hasError = true
                element.valid = false
                rs[key] = element
            }
        }
        if (raiseReason == '') {
            hasError = true
            setRaiseValid(false)
        }
        if (hasError) {
            setRaise(rs)
        } else {


            var info = {
                "unitId": props.unitId,
                "changeTypeId": raiseReason.value,
                "comment": raise.comment.value,
                "value": raise.amount.value?.toString().replace(/[^0-9]/g, ""),
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'management/api/v1/units/increaseUnitBalanace'
            fetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == '0') {
                        props.reload();
                    }
                })
                .catch(error => console.log(error))


        }
    }
    const changeRaiseReason = (selectedOption) => {
        setRaiseReason(selectedOption)
    }
    const inputChangedHandler = (event, controlName) => {
        let val = controlName == 'amount' ? event.target.value.toString().replace(/[^0-9]/g, "") : event.target.value
        let value = controlName == 'amount' ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : val
        const updatedControls = updateObject(raise, {
            [controlName]: updateObject(raise[controlName], {
                value: value,
                valid: checkValidity(event.target.value, raise[controlName].validation)
            })
        });
        setRaise(updatedControls);
    }
    let raiseReasonList = []
    if (raiseReasons != null && raiseReasons.length != 0) {
        raiseReasons.map(b => {
            raiseReasonList.push({
                value: b.id,
                label: b.description
            })
        })
    }
    const selectClass = raiseValid ? "UnitSelectBox" : "UnitInvalidSelect"

    const formElementsArray = [];
    for (let key in raise) {
        formElementsArray.push({
            id: key,
            config: raise[key]
        });
    }
    let form = formElementsArray.map(formElement => {
        let className = '6 mt-3'
        if (formElement.id == 'comment') {
            className = '12 mt-3'
        }
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col={className}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });

    return (
        <div>
            <div className="row justify-content-center">
                اطلاعات افزایش موجودی
            </div>
            <div className="col-12">
                <Row xs={2} >
                    <Select
                        name="form-field-name"
                        value={raiseReason}
                        inModal={true}
                        placeholder="علت افزایش اعتبار"
                        options={raiseReasonList}
                        onChange={changeRaiseReason}
                        className={selectClass}
                        col="6 mt-3"
                    />
                    {form}
                </Row>
                <div className="row justify-content-center">
                    <Button btnType="Success" clicked={raiseSubmit} >ثبت</Button>
                </div>
            </div>
        </div>
    )
}
export default RaiseCredit;